export default __webpack_public_path__ + "static/media/ticket-background.171b64cf.svg";